import script from "./AppUnderMaintenance.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUnderMaintenance.vue?vue&type=script&setup=true&lang=js"

import "./AppUnderMaintenance.vue?vue&type=style&index=0&id=fcf61bdc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcf61bdc"]])

export default __exports__